export * from './lib/editor.module';
